import React from "react";
import { Link } from "react-router-dom";
import { Tab, Icon } from "semantic-ui-react";

import { ModalSplitForm } from './modalSplitForm';
import { Caption, ButtonRow, Button, ButtonLabel } from './common';

// import styled from "tachyons-components";
import styles from "./styles.module.scss";
import { LEVER_TYPE, ConnectedSlider, ConnectedToggle, ConnectedNumberInput } from './numberSelectors';


const GrowthRateSelector = (props) => {
  return <div className={styles.selectorRow} style={{marginLeft: 0}}>
    <div className={styles.splitIcon}>
      <Icon name={props.icon} />{" "}
    </div>
    <div className={styles.questionLabel}>{props.name}</div>
    <div className={styles.splitSlider}>
      <ConnectedSlider leverName={props.lever} scenarioKey={props.scenarioKey} />
    </div>
  </div>;
}

const BooleanQuestion = (props) => {
  return <div className={styles.selectorRow}>
    <div className={styles.questionLabel}>
      {props.description}
    </div>
    <div className={styles.splitSlider}>
      <ConnectedToggle scenarioKey={props.scenarioKey} leverName={props.leverName} />
    </div>
  </div>;
}

// Free number
const NumberField = (props) => {
  return <div className={styles.selectorRow}>
    <div className={styles.questionLabel}>
      {props.label}
    </div>
    <div className={styles.numberHolder}>
      <ConnectedNumberInput
        leverName={props.lever}
        step={props.step}
      />
    </div>
  </div>;
}

const InputPane = () => {

  const booleanQuestions = [
    { lever: LEVER_TYPE.hasCngRegulation, description: "Does the city currently (or within the next year) require commercially operated vehicles (3-wheel, 4-wheel, and buses) to operate on compressed natural gas (CNG)?" },
    { lever: LEVER_TYPE.hasMajorHills, description: "Is your city predominately hilly?" },
  ];

  const growthRates = [
    { name: "Population growth rate to 2035", lever: LEVER_TYPE.populationGrowthRate },
    { name: "GDP Growth Rate to 2035", lever: LEVER_TYPE.economicGrowthRate },
  ];

  // CityBasics
  const cityDemographics = [
    { lever: LEVER_TYPE.population, label: 'Current Population', step: 50000 },
    { lever: LEVER_TYPE.grossDomesticProduct, label: 'Current Gross Domestic Product (USD)', step: 100000 }
  ]

  return <Tab.Pane attached={true}>
    <Caption>
      Please set the parameters for your city using the data fields.
      </Caption>

    <NumberField
      {...cityDemographics[0]}
    />

    <GrowthRateSelector
      {...growthRates[0]}
    />

    <NumberField
      {...cityDemographics[1]}
    />

    <GrowthRateSelector
      {...growthRates[1]}
    />


    <BooleanQuestion
      description={booleanQuestions[0].description}
      leverName={booleanQuestions[0].lever}
    />

    <BooleanQuestion
      description={booleanQuestions[1].description}
      leverName={booleanQuestions[1].lever}
    />


    <NumberField
      label={'Current Motorized Passenger Transport Demand per Capita per year (kilometers)'}
      lever={LEVER_TYPE.passengerDistanceTraveled}
      step={100}
    />

    <ModalSplitForm />

    <ButtonRow>
      <Link to="/levers">
        <Button>
          <ButtonLabel>Next > </ButtonLabel>
        </Button>
      </Link>
    </ButtonRow>
  </Tab.Pane>;
}

export default InputPane;



// WEBPACK FOOTER //
// ./src/pages/modelCity/panes/input.js